// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Nnyiz","white":"styles_white__M48Tu"};